import { observer } from "mobx-react-lite";

import { MaybeAssignedValue } from "src/components/WorkoutSetMaybeAssignedValue";
import { ExerciseAttributeInput } from "src/workouts/ExerciseAttributeInput";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";
import { useWorkoutSetsWorkoutItemSetsContext } from "src/workouts/WorkoutItemSetContext.shared";
import { type ExerciseAttributeProps } from "src/workouts/WorkoutItemSets.types";

export const ExerciseAttribute = observer(function ExerciseAttribute(
  props: ExerciseAttributeProps,
) {
  const workoutItemSetsContext = useWorkoutSetsWorkoutItemSetsContext();

  const workoutEditStore = useWorkoutEditStore();

  const attributeValues =
    workoutEditStore.attributeValuesBySetAndAttribute[props.workoutSet.id];

  if (!attributeValues) {
    return (
      <div>
        {props.workoutSet.id} {JSON.stringify(attributeValues)}
      </div>
    );
  }

  const attributeValue = attributeValues[props.attribute.exerciseAttributeId];

  const historySet = props.latestHistory?.sets[props.setIndex];
  const historyAttr = historySet?.attributes.find((a) => {
    return a.name === props.attribute.exerciseAttribute.name;
  });
  const historyValue = historyAttr?.trackedValue || historyAttr?.assignedValue;

  return (
    <workoutItemSetsContext.Provider
      workoutSet={props.workoutSet}
      attribute={props.attribute}
      attributeValue={attributeValue}
    >
      {/* A label, so clicking anywhere in the cell focuses its input. */}
      <label className="flex h-9 items-center gap-2 px-2 text-xs">
        <MaybeAssignedValue></MaybeAssignedValue>
        <div className="relative inline-flex flex-1">
          <ExerciseAttributeInput />
        </div>
        {historyValue ? (
          <span className="text-xs text-muted-foreground">{historyValue}</span>
        ) : null}
      </label>
    </workoutItemSetsContext.Provider>
  );
});
